import { doc, getDoc, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetSingleHostelRoom = async (RoomID) => {
  try {
    const RoomDocument = doc(db, "Hostel", RoomID);
    const RoomSnapshot = await getDoc(
      RoomDocument,
      where("IsDeleted", "==", false)
    );

    let Room = { ...RoomSnapshot.data(), id: RoomSnapshot.id };

    return Room;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleHostelRoom;
